module.exports = __webpack_public_path__ + "static/media/farm-logo.a858ef3e.png";